export default __webpack_public_path__ + "static/media/testimonials-slider.6abd6b01.png";